// extracted by mini-css-extract-plugin
export default {"container":"Nudger_container__NLs5u","text-container":"Nudger_text-container__DtOZr","button-container":"Nudger_button-container__aXNk3","counter":"Nudger_counter__nkoWh"};